export class RouteLine {
  constructor(
    readonly id: number,
    readonly name: string,
    readonly mrt: string,
  ) {}


  public static fromBE(plain: RouteLineBE): RouteLine {
    const { id, name, mrt } = plain;
    return new RouteLine(id, name, mrt);
  }
}

export interface RouteLineBE {
  readonly id: number;
  readonly name: string;
  readonly mrt: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/RouteLine.ts